<template>
  <div>
    <ErrorPage v-if="error404occured" />
    <div v-else class="api-catalogue">
      <div class="container pl-0">
        <div aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home', params: { lang: $route.params.lang }}">{{ $t('CC01-03-08') }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'api-catalogue', params: { category: 'all', lang: $route.params.lang }}">{{ $t('M06a-03') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page"><a class="disabled">{{ $t(categoryName) }}</a></li>
          </ol>
        </div>
      </div>
      <div id="scroll-to-div" />
      <div v-if="specialCategoryInfo" class="container mb-5">
        <div id="category-banner" class="p-4 p-lg-5 rounded">
          <h2>{{ $t(categoryName) }}</h2>
          <span class="category-banner-description">{{ specialCategoryInfo ? specialCategoryInfo[$i18n.locale].banner_description : '' }}</span>
        </div>
      </div>
      <div class="container">
        <!-- <h1 class="mb-5">{{ $t('M06a-03') }}</h1> -->
        <div class="row">
          <!-- Sticky sidebar -->
          <div id="stickyBlockStartPoint" class="col-xl-3 col-lg-2 pr-xl-5 mb-5 mb-lg-0">
            <!-- Filter -->
            <div>
              <div class="navbar-expand-lg navbar-expand-lg-collapse-block">
                <!-- Responsive Toggle Button -->
                <button v-b-toggle.sidebarNav class="navbar-toggler btn btn-block border py-3" aria-label="Toggle navigation">
                  <span class="d-flex justify-content-between align-items-center">
                    <span class="h5 mb-0">{{ $t('M06a-04-mobile') }}</span>
                    <span class="navbar-toggler-default">
                      <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                        <path fill="currentColor" d="M17.4,6.2H0.6C0.3,6.2,0,5.9,0,5.5V4.1c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,5.9,17.7,6.2,17.4,6.2z M17.4,14.1H0.6c-0.3,0-0.6-0.3-0.6-0.7V12c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,13.7,17.7,14.1,17.4,14.1z" />
                      </svg>
                    </span>
                    <span class="navbar-toggler-toggled">
                      <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                        <path fill="currentColor" d="M11.5,9.5l5-5c0.2-0.2,0.2-0.6-0.1-0.9l-1-1c-0.3-0.3-0.7-0.3-0.9-0.1l-5,5l-5-5C4.3,2.3,3.9,2.4,3.6,2.6l-1,1 C2.4,3.9,2.3,4.3,2.5,4.5l5,5l-5,5c-0.2,0.2-0.2,0.6,0.1,0.9l1,1c0.3,0.3,0.7,0.3,0.9,0.1l5-5l5,5c0.2,0.2,0.6,0.2,0.9-0.1l1-1 c0.3-0.3,0.3-0.7,0.1-0.9L11.5,9.5z" />
                      </svg>
                    </span>
                  </span>
                </button>
                <!-- End Responsive Toggle Button -->

                <b-collapse id="sidebarNav" class="collapse navbar-collapse">
                  <!-- Workspaces -->
                  <!-- <div class="mt-5 mb-5 mt-lg-0">
                    <h4>{{ $t('M06a-04-01') }}</h4>
                    <div class=" tag-container">
                      <a
                        v-for="item in workspaceList"
                        :key="item.value"
                        class="category-filter dropdown-item d-flex justify-content-between align-items-center px-0"
                        :class="{ active: currentCategory.toLowerCase() == item.value.toLowerCase() }"
                        @click="filterCards(item.value)"
                      >
                        {{ $t(item.label) }}
                      </a>
                    </div>
                  </div> -->

                  <!-- Collections -->
                  <div v-if="collectionsList.length > 0" class="mt-5 mb-5 mt-lg-0">
                    <h4>{{ $t('CC02-03e') }}</h4>
                    <div class=" tag-container">
                      <a
                        v-for="item in collectionsList"
                        :key="item.value"
                        class="category-filter dropdown-item d-flex justify-content-between align-items-center px-0"
                        :class="{ active: currentCategory.toLowerCase() == item.value.toLowerCase() }"
                        @click="filterCards(item.value)"
                      >
                        {{ $t(item.label) }}
                      </a>
                    </div>
                  </div>

                  <!-- Categories -->
                  <!-- <div class="mt-5 mt-lg-0">
                    <h4>{{ $t('CC02-03c') }}</h4>
                    <div class="tag-container">
                      <a
                        v-for="categoryItem in categories.slice(0, 10)"
                        :key="categoryItem.value"
                        class="category-filter dropdown-item d-flex justify-content-between align-items-center px-0"
                        :class="{ active: currentCategory == categoryItem.value }"
                        @click="filterCards(categoryItem.value)"
                      >
                        {{ $t(categoryItem.label) }}
                      </a>
                      <div class="cursor-pointer" @click="redirectToAllCategories">
                        <div v-if="categories.length > 10" class="mt-2 link-collapse font-weight-bold">
                          <span class="font-weight-bold"><i class="fas fa-th mr-2" />{{ $t('M06a-04-mobile') }}</span>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </b-collapse>
              </div>
            </div>
            <!-- End Filter -->
          </div>
          <!-- End Sticky Sidebar -->

          <!-- Main Partners List Section -->
          <div class="col-xl-9 col-lg-10 mb-0 main-container">
            <!-- ===== Partners ===== -->
            <div class="space-bottom-2">
              <h3 class="mb-4">{{ (categoryName.includes('M06a') || categoryName.includes('CC02')) ? $t(categoryName) : `${$t(categoryName)} ${$t('M06a-05b')}` }}</h3>
              <div class="mb-4 px-1">
                <form v-if="!categoryName.includes('CC02')" class="input-group input-group-merge" onsubmit="return false;">
                  <input ref="searchKeywordInput" v-model="searchKey" type="search" class="form-control" :placeholder="`${$t('CC06-02-01')} ${$t('M06a-05b')}`" :aria-label="`${$t('CC06-02-01')} ${$t('M06a-05b')}`" aria-describedby="searchAPIs" @input="searchApi">
                  <div class="input-group-append">
                    <span id="searchAPI" class="input-group-text">
                      <i class="fas fa-search" />
                    </span>
                  </div>
                </form>
              </div>
              <div v-if="getEditableInfo('enabled_function', 'verification_badge', false)" class="mb-4 px-1">
                <div class="info-message-box">
                  <i class="info-message-icon fas fa-info-circle" />
                  <div class="info-message-text">
                    <div class="info-description">
                      <span>{{ $t('M06a-06a') }}</span>
                      <img height="20" src="@/assets/svg/illustrations/oah-verification-badge.svg">
                      <span :class="{ 'mr-1': $route.params.lang === 'en-us' }">{{ $t('M06a-06b') }}</span>
                      <a class="link-text" :href="getEditableInfo('user_guide', 'what-is-verification-badge')" target="_blank">{{ $t('M06a-06c') }}</a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Card Items -->
              <div class="row api-card-row">
                <div v-if="currentCategory === 'Partner-Shared-APIs' && currentPage === 1" class="col-lg-4 col-md-6 col-sm-12 mb-5">
                  <InfoCard
                    gaId="ga-CC05-2-01"
                    :to="{ type: 'link', link: getEditableInfo('user_guide', 'invite-developers-to-partner-api-as-providers') }"
                    title="CC05-2-02"
                    description="CC05-2-03"
                    :showDeveloperInfo="true"
                    :withDeveloperInfo="loggedIn && userProfile.id !== ''"
                  />
                </div>
                <div v-for="(api, index) in beforeItems" :key="loaded ? api.name : index" class="col-lg-4 col-md-6 col-sm-12 mb-5">
                  <ApiCardBranded :item="api" :clickHandler="goToApiInfo" :fromApiCarousel="false" :loading="!loaded" afterLogin="apiReadmeBranded" />
                </div>
                <div v-if="workspaceList.findIndex(workspace => workspace.value === currentCategory) === -1 && noOfAPIs > 5 && currentPage === 1" class="col-lg-4 col-md-6 col-sm-12 mb-5">
                  <InfoCard
                    :to="{ ...getEditableInfo('provider_leads_card', 'action', false) }"
                    title="CC05-6-02"
                    description="CC05-6-03"
                    :showDeveloperInfo="true"
                    :withDeveloperInfo="loggedIn && userProfile.id !== ''"
                  />
                </div>
                <div v-for="(api, index) in afterItems" :key="loaded ? api.name : index" class="col-lg-4 col-md-6 col-sm-12 mb-5">
                  <ApiCardBranded :item="api" :clickHandler="goToApiInfo" :fromApiCarousel="false" :loading="!loaded" afterLogin="apiReadmeBranded" />
                </div>
                <div v-if="currentCategory === 'Subscribed-APIs' && currentPage === showSecondLastCardPage" class="col-lg-4 col-md-6 col-sm-12 mb-5">
                  <InfoCard
                    :to="{ type: 'router', name: 'api-catalogue', params: { category: 'all', lang: $route.params.lang } }"
                    title="CC05-4-02"
                    description="CC05-4-03"
                    :showDeveloperInfo="true"
                    :withDeveloperInfo="loggedIn && userProfile.id !== ''"
                  />
                </div>
                <div v-else-if="currentCategory === 'My-Uploaded-APIs' && currentPage === showSecondLastCardPage" class="col-lg-4 col-md-6 col-sm-12 mb-5">
                  <InfoCard
                    :to="{ type: 'link', link: `${DEVELOPER_PORTAL_URL}/#/be-a-provider` }"
                    title="CC05-7-02"
                    description="CC05-7-03"
                    :showDeveloperInfo="true"
                    :withDeveloperInfo="loggedIn && userProfile.id !== ''"
                  />
                </div>
                <div v-if="currentCategory === 'Partner-Shared-APIs' && currentPage === totalPageNum" class="col-lg-4 col-md-6 col-sm-12 mb-5">
                  <InfoCard
                    :to="{ type: 'link', link: getEditableInfo('user_guide', 'why-cant-i-see-my-partners-api') }"
                    title="CC05-3-02"
                    description="CC05-3-03"
                    :showDeveloperInfo="true"
                    :withDeveloperInfo="loggedIn && userProfile.id !== ''"
                  />
                </div>
                <div v-else-if="currentCategory === 'Subscribed-APIs' && currentPage === totalPageNum" class="col-lg-4 col-md-6 col-sm-12 mb-5">
                  <InfoCard
                    :to="{ ...getEditableInfo('new_idea_api_card', 'action', false) }"
                    title="CC05-5-02"
                    description="CC05-5-03"
                    :showDeveloperInfo="true"
                    :withDeveloperInfo="loggedIn && userProfile.id !== ''"
                  />
                </div>
                <div v-else-if="currentCategory === 'My-Uploaded-APIs' && currentPage === totalPageNum" class="col-lg-4 col-md-6 col-sm-12 mb-5">
                  <InfoCard
                    :to="{ ...getEditableInfo('provider_leads_card', 'action', false) }"
                    title="CC05-6-02"
                    description="CC05-6-03"
                    :showDeveloperInfo="true"
                    :withDeveloperInfo="loggedIn && userProfile.id !== ''"
                  />
                </div>
                <div v-else-if="noOfAPIs > 5 && currentPage === totalPageNum" class="col-lg-4 col-md-6 col-sm-12 mb-5">
                  <InfoCard
                    :to="{ ...getEditableInfo('new_idea_api_card', 'action', false) }"
                    title="CC05-5-02"
                    description="CC05-5-03"
                    :showDeveloperInfo="true"
                    :withDeveloperInfo="loggedIn && userProfile.id !== ''"
                  />
                </div>
                <div v-if="workspaceList.findIndex(workspace => workspace.value === currentCategory) === -1 && noOfAPIs > 0 && noOfAPIs <= 5" class="col-lg-4 col-md-6 col-sm-12 mb-5">
                  <InfoCard
                    :to="{ ...getEditableInfo('new_idea_api_card', 'action', false) }"
                    title="CC05-5-02"
                    description="CC05-5-03"
                    :showDeveloperInfo="true"
                    :withDeveloperInfo="loggedIn && userProfile.id !== ''"
                  />
                </div>
                <div v-if="workspaceList.findIndex(workspace => workspace.value === currentCategory) === -1 && noOfAPIs > 0 && noOfAPIs <= 5" class="col-lg-4 col-md-6 col-sm-12 mb-5">
                  <InfoCard
                    :to="{ ...getEditableInfo('provider_leads_card', 'action', false) }"
                    title="CC05-6-02"
                    description="CC05-6-03"
                    :showDeveloperInfo="true"
                    :withDeveloperInfo="loggedIn && userProfile.id !== ''"
                  />
                </div>
              </div>
              <!-- End Card Items  -->
            </div>
            <!-- ===== Partners ===== -->

            <div v-if="noOfAPIs === 0 && loaded && showNotFound" class="result-container">
              <div class="space-1" />
              <div class="w-100 d-block">
                <div class="text-center">
                  <div>{{ $t('M06a-08-01') }}</div>
                  <div class="pb-3">{{ $t('M06a-08-02') }}</div>
                  <div>{{ $t('M06a-08-03a') }}<a class="link-text" @click="redirect({ ...getEditableInfo('new_idea_api_card', 'action', false) })">{{ $t('M06a-08-03b') }}</a>{{ $t('M06a-08-03c') }}</div>
                </div>
                <div v-if="editors_pick_api.length > 0" class="container trending-api-section">
                  <hr class="my-5">
                  <div class="text-center pb-1">
                    <h3>{{ $t('M06a-08-04') }}</h3>
                  </div>
                  <div class="w-md-100 w-90 mx-auto h-100">
                    <ApiCarousel
                      class="api-carousel-trending"
                      :items="shuffleArray(editors_pick_api)"
                      :apiCardClickHandler="goToApiInfo"
                      carouselId="api-carousel-editors-pick"
                      :loading="false"
                      :isFromApiCatalogue="true"
                      :isNotShowInfoCard="true"
                    />
                  </div>
                </div>
                <!-- ========== End Editor's Pick APIs ========== -->
              </div>
              <div class="space-1" />
            </div>
            <!-- <div v-if="noOfAPIs === 0 && searchKey==='' && loaded && showNotFound" class="text-center">
              <img class="w-lg-40 w-50" src="@/assets/svg/illustrations/empty.svg" alt="No API svg">
              <p>{{ $t('CC02-03c-02') }}</p>
              <span class="d-block mt-5">
                <router-link :to="{ name: 'use-cases-overview', params: { lang: $route.params.lang }}" class="btn btn-primary btn-wide">{{ $t('CC02-03f') }}</router-link>
              </span>
            </div> -->

            <!-- === Pagination -->
            <div v-if="(noOfAPIs > 0 || !showNotFound)" aria-label="Page navigation example">
              <Pagination
                :page="currentPage"
                :page-number="totalPageNum"
                :page-change-handler="pageChange"
              />
            </div>
            <!-- === End Pagination -->

          </div>
        </div>
        <!-- End Main API List Section -->

        <!-- Sticky Block End Point -->
        <div id="stickyBlockEndPoint" />

        <div class="space-top-3" />

      </div>
      <!-- ========== Go to Top ========== -->
      <a
        aria-label="go-to-top"
        class="js-go-to go-to position-fixed invisible"
        href="#stickyBlockStartPoint"
        data-hs-go-to-options="{
        &quot;targetSelector&quot; : &quot;#logoAndNav&quot;,
        &quot;offsetTop&quot;: 200,
        &quot;position&quot;: {
          &quot;init&quot;: {
            &quot;right&quot;: 30
          },
          &quot;show&quot;: {
            &quot;bottom&quot;: 30
          },
          &quot;hide&quot;: {
            &quot;bottom&quot;: -30
          }
        }
      }"
      >
        <i class="fas fa-angle-up" />
      </a>
      <!-- ========== End Go to Top ========== -->
    </div>
    <b-modal id="hubspotFormModal" ref="hubspotFormModal" class="fade hubspot-form-dialog" centered hide-footer>
      <template slot="modal-header-close">
        <button type="button" class="btn btn-xs btn-icon btn-soft-secondary" data-dismiss="modal" aria-label="Close">
          <img :src="require(`@/assets/svg/icons/icon-68.svg`)">
        </button>
      </template>
      <div class="w-md-90 mx-auto mb-6 form-submit">
        <div id="hubspotForm" />
      </div>
    </b-modal>
  </div>
</template>
<script>
const $ = require('jquery')
import ApiCardBranded from '@/components/api-card-branded'
import ApiCarousel from '@/components/api-carousel'
import InfoCard from '@/components/info-card'
import Pagination from '@/components/pagination'
import HSStickyBlock from '@/assets/vendor/hs-sticky-block/src/js/hs-sticky-block'
import HSGoTo from '@/assets/vendor/hs-go-to/src/js/hs-go-to'
import ErrorPage from '@/views/error-page/index.vue'
import { searchListingAPI } from '@/api/profile'
import { getCategoryList } from '@/api/api-catalogue'
import { mapGetters } from 'vuex'
import Axios from 'axios'
import _ from 'lodash'
import DummyApiCardData from '@/data/api-card-dummy-data'
import { getCategoryCode, getCategoryKeyCodeByValue, getCategoryFormattedName } from '@/utils/format-util'
import getRuntimeConfig from '@/utils/get-runtime-config'
import { getEditorsApiData } from '@/utils/get-static-data-util'
import getEditableInfo from '@/utils/get-editable-info'
import shuffleArray from '@/utils/shuffle-array-util'

export default {
  name: 'ApiCatalogue',
  components: {
    ApiCardBranded,
    ApiCarousel,
    InfoCard,
    ErrorPage,
    Pagination
  },
  data() {
    return {
      DEVELOPER_PORTAL_URL: '',
      workspaceList: [
        { label: 'M06a-05a-01', value: 'Subscribed-APIs' },
        { label: 'M06a-05a-02', value: 'Partner-Shared-APIs' },
        { label: 'M06a-05a-03', value: 'My-Uploaded-APIs' }
      ],
      collectionsList: [{ label: getCategoryCode('ALL'), value: 'ALL' }],
      editors_pick_api: [],
      sponsored_api: [],
      free_api: [],
      showNotFound: true,
      currentPage: 1,
      noOfAPIs: 0,
      visibleCard: [
        DummyApiCardData, DummyApiCardData, DummyApiCardData, DummyApiCardData,
        DummyApiCardData, DummyApiCardData, DummyApiCardData, DummyApiCardData,
        DummyApiCardData, DummyApiCardData, DummyApiCardData, DummyApiCardData
      ],
      searchKey: '',
      currentCategory: '',
      items: [],
      cards: [],
      categories: [],
      special_categories: {},
      error404occured: false,
      loaded: false,
      accordionActive: false,
      insertedRuleNo: 0,
      previousRequest: null,
      handleSearchKeyChange: _.debounce(async function() {
        await this.cancelPreviousRequest()
      }, 200, { 'maxWait': 250 })
    }
  },
  computed: {
    userProfile() {
      return this.$store.getters.userProfile
    },
    tableOffset() {
      if (this.currentCategory === 'Partner-Shared-APIs') {
        switch (this.currentPage) {
          case 1:
            return 0
          case 2:
            return 11
          default:
            return ((this.currentPage - 2) * this.pageSize) + 11
        }
      } else if (this.currentCategory === 'My-Uploaded-APIs' || this.currentCategory === 'Subscribed-APIs') {
        return ((this.currentPage - 1) * this.pageSize)
      } else {
        switch (this.currentPage) {
          case 1:
            return 0
          case 2:
            return 11
          default:
            return ((this.currentPage - 2) * this.pageSize) + 11
        }
      }
    },
    pageSize() {
      if (this.currentCategory === 'Partner-Shared-APIs') {
        return this.currentPage === 1 ? 11 : 12
      } else if (this.currentCategory === 'My-Uploaded-APIs' || this.currentCategory === 'Subscribed-APIs') {
        return 12
      } else {
        return this.currentPage === 1 ? 11 : 12
      }
    },
    totalPageNum() {
      if (this.currentCategory === 'Partner-Shared-APIs') {
        return (this.noOfAPIs - 11) % 12 !== 0 ? Math.ceil((this.noOfAPIs - 11) / 12) + 1 : Math.ceil((this.noOfAPIs - 11) / 12) + 2
      } else if (this.currentCategory === 'My-Uploaded-APIs' || this.currentCategory === 'Subscribed-APIs') {
        return this.noOfAPIs % 12 !== 0 && this.noOfAPIs % 12 !== 11 ? Math.ceil(this.noOfAPIs / 12) : Math.ceil(this.noOfAPIs / 12) + 1
      } else {
        return (this.noOfAPIs - 11) % 12 !== 0 ? Math.ceil((this.noOfAPIs - 11) / 12) + 1 : Math.ceil((this.noOfAPIs - 11) / 12) + 2
      }
    },
    showSecondLastCardPage() {
      if (this.noOfAPIs % 12 === 0) {
        return this.totalPageNum
      } else if (this.noOfAPIs % 12 === 11) {
        return this.totalPageNum - 1
      } else {
        return this.totalPageNum
      }
    },
    categoryName() {
      console.log('this.categories', this.categories, this.currentCategory)
      if (this.categories !== [] && this.currentCategory !== '') {
        switch (this.currentCategory.toLowerCase()) {
          case 'Subscribed-APIs'.toLowerCase():
            return 'M06a-05a-01'
          case 'Partner-Shared-APIs'.toLowerCase():
            return 'M06a-05a-02'
          case 'My-Uploaded-APIs'.toLowerCase():
            return 'M06a-05a-03'
          case 'editors-pick'.toLowerCase():
            return 'CC02-03f-01'
          // case 'sponsored'.toLowerCase():
          //   return 'CC02-03f-03'
          case 'free-api'.toLowerCase():
            return 'CC02-03f-02'
          // default:
          //   return this.categories.find(c => c.value === this.currentCategory) ? this.categories.find(c => c.value === this.currentCategory).label : ''
          default:
            return this.collectionsList.find(c => c.value.toLocaleLowerCase() === this.currentCategory.toLocaleLowerCase()) ? this.collectionsList.find(c => c.value.toLocaleLowerCase() === this.currentCategory.toLocaleLowerCase()).label : this.categories.find(c => c.value === this.currentCategory) ? this.categories.find(c => c.value === this.currentCategory).label : ''
        }
      } else return ''
    },
    beforeItems() {
      return this.noOfAPIs > 5 ? this.visibleCard.slice(0, 4) : this.visibleCard
    },
    afterItems() {
      return this.noOfAPIs > 5 ? this.visibleCard.slice(4, this.visibleCard.length) : []
    },
    loggedIn() {
      return this.$store.getters.login
    },
    specialCategoryInfo() {
      return this.special_categories[this.currentCategory]
    },
    ...mapGetters(['loading', 'site_info'])
  },
  watch: {
    userProfile: {
      deep: true,
      async handler(newProfile) {
        this.$store.dispatch('app/setLoading', true)
        this.loaded = false
        if (this.currentCategory === '') {
          if (this.$route.params && this.$route.params.category) {
            this.currentCategory = this.workspaceList.find(item => item.value.toLowerCase() === this.$route.params.category.toLowerCase()) || this.collectionsList.find(item => item.value.toLowerCase() === this.$route.params.category.toLowerCase()) ? this.$route.params.category : getCategoryKeyCodeByValue(this.$route.params.category)
          }
        }
        if ((newProfile.id !== '') && (newProfile.id !== this.userProfile.id)) {
          await this.getAPIList()
        }
        this.loaded = true
        this.$store.dispatch('app/setLoading', false)
      }
    },
    async $route() {
      this.$store.dispatch('app/setLoading', true)
      this.loaded = false
      if (this.$route.params && this.$route.params.category) {
        this.currentCategory = this.workspaceList.find(item => item.value.toLowerCase() === this.$route.params.category.toLowerCase()) || this.collectionsList.find(item => item.value.toLowerCase() === this.$route.params.category.toLowerCase()) ? this.$route.params.category : getCategoryKeyCodeByValue(this.$route.params.category)
      }
      this.error404occured = false
      if (this.userProfile.id !== '') {
        await this.getAPIList()
      }
      this.loaded = true
      this.$store.dispatch('app/setLoading', false)
    },
    categoryName() {
      this.changeTabName()
    },
    '$i18n.locale'() {
      this.changeTabName()
    },
    specialCategoryInfo() {
      if (this.specialCategoryInfo) {
        var sheet = window.document.styleSheets[0]
        sheet.insertRule(
          `#category-banner {
            background: url(${require(`@/assets/img/category-banner/${this.specialCategoryInfo.banner_image_url}`)}) right bottom no-repeat, linear-gradient(${this.specialCategoryInfo.gradient_bg_color});
          }`,
          sheet.cssRules.length
        )
        this.insertedRuleNo = this.insertedRuleNo + 1
      }
    }
  },
  beforeDestroy() {
    for (let i = 0; i < this.insertedRuleNo; i++) {
      window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
    }
  },
  mounted() {
    new HSStickyBlock($('.js-sticky-block')).init()
    new HSGoTo($('.js-go-to')).init()
  },
  async created() {
    this.loaded = false
    const runtimeConfig = await getRuntimeConfig()
    this.DEVELOPER_PORTAL_URL = runtimeConfig.DEVELOPER_PORTAL_URL
    if (this.$route.query && this.$route.query.key) {
      this.searchKey = this.$route.query.key
    }

    //  Read editor's API data.
    const editorsApiData = await getEditorsApiData()
    if (editorsApiData) {
      if (editorsApiData.editorsPickApis?.display) {
        this.collectionsList.push({ label: 'CC02-03f-01', value: 'editors-pick' })
        this.editors_pick_api = editorsApiData.editorsPickApis.data
        this.special_categories = editorsApiData.specialCategories ? editorsApiData.specialCategories : []
      }

      if (editorsApiData.sponsoredApis?.display) {
        // this.collectionsList.push({ label: 'CC02-03f-03', value: 'sponsored' })
        this.sponsored_api = editorsApiData.sponsoredApis.data
      }

      if (editorsApiData.freeApis?.display) {
        this.collectionsList.push({ label: 'CC02-03f-02', value: 'free-api' })
        this.free_api = editorsApiData.freeApis.data
      }
    }

    await this.getAPICategoryListInfo()
    if (this.currentCategory === '') {
      if (this.$route.params && this.$route.params.category) {
        this.currentCategory = this.workspaceList.find(item => item.value.toLowerCase() === this.$route.params.category.toLowerCase()) || this.collectionsList.find(item => item.value.toLowerCase() === this.$route.params.category.toLowerCase()) ? this.$route.params.category : getCategoryKeyCodeByValue(this.$route.params.category)
      }
    }
    await this.getAPIList()
    this.loaded = true
    this.$store.dispatch('app/setLoading', false)
  },
  methods: {
    changeTabName() {
      if (this.categoryName.includes('M06a') || this.categoryName.includes('CC02')) {
        document.title = `${this.$t(this.categoryName)} | ${this.site_info[this.$i18n.locale].name}`
      } else if (this.categoryName !== '' && !this.categoryName.includes('ALL')) {
        document.title = `${this.$t(this.categoryName)} APIs | ${this.site_info[this.$i18n.locale].name}`
      } else {
        document.title = `${this.$t('M06a-03')} | ${this.site_info[this.$i18n.locale].name}`
      }
    },
    async cancelPreviousRequest() {
      if (this.previousRequest) {
        this.previousRequest.cancel()
        this.previousRequest = null
      }
      await this.getAPIList()
    },
    async pageChange(val) {
      this.handleCurrentChange(val)
      await this.handleSearchKeyChange()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.$router.push({ name: 'api-catalogue', params: { category: this.workspaceList.find(item => item.value.toLowerCase() === this.currentCategory.toLowerCase()) || this.collectionsList.find(item => item.value.toLowerCase() === this.currentCategory.toLowerCase()) ? this.currentCategory.toLowerCase() : getCategoryFormattedName(this.currentCategory) }})
    },
    async filterCards(val) {
      this.$store.dispatch('app/setLoading', true)
      this.loaded = false
      this.currentCategory = val
      this.searchKey = ''
      await this.pageChange(1)
      this.$store.dispatch('app/setLoading', false)
    },
    async getAPICategoryListInfo() {
      try {
        const { data: categoryList } = await getCategoryList()
        const editorsApiData = await getEditorsApiData()
        const popular_category_list = editorsApiData.popularCategoryList
        var popularList = categoryList.filter(c => popular_category_list.includes(c.content_key))
        var options = []
        if (popular_category_list && popular_category_list.length > 0) {
          options = popular_category_list.map(category => {
            return popularList.find(c => c.content_key === category)
          })
        }
        var commonList = categoryList.filter(c => !popular_category_list.includes(c.content_key) && c.content_value !== 'Others' && c.content_value !== 'Archived')
        var endList = categoryList.filter(c => c.content_value === 'Others' || c.content_value === 'Archived')
        if (commonList && commonList.length > 0) {
          // Sort category options label in alphabetical order
          commonList.sort((a, b) => {
            return a.content_value.toLowerCase() > b.content_value.toLowerCase() ? 1 : b.content_value.toLowerCase() > a.content_value.toLowerCase() ? -1 : 0
          })
        }
        if (endList && endList.length > 0) {
          // Sort category options label in alphabetical order
          endList.sort((a, b) => {
            return a.content_value.toLowerCase() < b.content_value.toLowerCase() ? 1 : b.content_value.toLowerCase() < a.content_value.toLowerCase() ? -1 : 0
          })
        }
        options = popularList.concat(commonList, endList)
        options = options.map(function(category) {
          return { label: getCategoryCode(category.content_key), value: category.content_key }
        })
        this.categories = [{ label: getCategoryCode('ALL'), value: 'ALL' }].concat(options)
      } catch (err) {
        this.categories = [{ label: getCategoryCode('ALL'), value: 'ALL' }]
      }
    },
    async searchApi(e) {
      this.searchKey = e.target.value
      await this.pageChange(1)
    },
    async getAPIList() {
      this.loaded = false
      if (
        this.categories.find(c => c.value === this.currentCategory) ||
        this.currentCategory === '' ||
        this.workspaceList.find(c => c.value.toLowerCase() === this.currentCategory.toLowerCase()) ||
        this.collectionsList.find(c => c.value.toLowerCase() === this.currentCategory.toLowerCase())
      ) {
        var filter = {}
        let allCards = []
        console.log('this.currentCategory', this.currentCategory)

        switch (this.currentCategory) {
          //  First handle if user is sesrching for Editor's Pick / Sponsored,
          //  as we will not be using API for this 2.
          case 'editors-pick'.toLowerCase():
          case 'sponsored'.toLowerCase():
          case 'free-api'.toLowerCase():
            allCards = this.currentCategory === 'editors-pick'
              ? this.editors_pick_api
              : this.currentCategory === 'sponsored'
                ? this.sponsored_api
                : this.free_api
            this.noOfAPIs = allCards.length

            //  Set visible cards according to current page
            this.visibleCard = allCards.slice(this.tableOffset, this.tableOffset + this.pageSize)
            // scroll to page title
            window.scrollTo({ top: $('#scroll-to-div').offset().top - 20, left: 0, behavior: 'smooth' })
            this.loaded = true
            this.previousRequest = null
            return

          case 'Subscribed-APIs'.toLowerCase():
            filter.subscribedApi = true
            break

          case 'Partner-Shared-APIs'.toLowerCase():
            filter.apiType = 'partner'
            break

          case 'My-Uploaded-APIs'.toLowerCase():
            filter.myUploadedApi = true
            break

          //  Nothing to handle for this case.
          case 'ALL':
          case 'all':
            break

          default:
            filter.categoryName = this.currentCategory
            break
        }

        if (this.searchKey !== '') {
          filter.searchKeyword = this.searchKey
        }
        const axiosSource = Axios.CancelToken.source()
        this.previousRequest = { cancel: axiosSource.cancel }
        await searchListingAPI(axiosSource.token, this.userProfile.id, this.pageSize, this.tableOffset, filter).then(res => {
          const response = res['data'].map(api => {
            return {
              ...api,
              api_id: api.id,
              api_short_id: api.short_id,
              api_name: api.name,
              api_type: api.accessibility,
              api_description: api.short_description,
              api_category: api.category,
              api_no_of_calls: api.request_count,
              api_errors_percentage: api.success_rate,
              api_latency: api.average_latency,
              api_provider_group: api.groups,
              display_name: api.provider_display_name
            }
          })
          this.visibleCard = response
          this.noOfAPIs = parseInt(res.headers['content-range'].split('/')[1])
          if (this.searchKeysearchkey !== '') {
            this.$refs.searchKeywordInput.focus()
          }
          // scroll to page title
          window.scrollTo({ top: $('#scroll-to-div').offset().top - 20, left: 0, behavior: 'smooth' })
          this.loaded = true
          this.previousRequest = null
        }).catch(err => {
          console.log(err)
          // scroll to page title
          this.visibleCard = []
          window.scrollTo({ top: $('#scroll-to-div').offset().top - 20, left: 0, behavior: 'smooth' })
          this.loaded = true
          this.previousRequest = null
          this.$store.dispatch('app/setLoading', false)
        })
      } else {
        this.error404occured = true
        this.loaded = true
      }
    },
    goToApiInfo(item) {
      try {
        const provider_name = (item.display_name.toLowerCase().replace(/[^A-Za-z0-9]/g, '-').concat(`-${item.provider_short_id}`)).replace(/\-+/g, '-')
        const api_name = (item.api_name.toLowerCase().replace(/[^A-Za-z0-9]/g, '-').concat(`-${item.api_short_id}`)).replace(/\-+/g, '-')
        const tab_name = 'readme'
        window.open(`${window.location.origin.replace('hub', 'portal').replace('openapihub', 'fabrixapi')}/${provider_name}/api/${api_name}/${tab_name}`, '_blank')
      } catch (err) {
        console.log('err in goToApiInfo', err)
      }
    },
    getCategoryName(category) {
      return this.$t(getCategoryCode(category))
    },
    getEditableInfo(type, id, withLangCode = true) {
      return getEditableInfo(type, id, withLangCode ? this.$i18n.locale : '')
    },
    redirectToAllCategories() {
      this.$router.push({
        name: 'all-categories',
        params: {
          ...this.$route.params
        }
      })
    },
    shuffleArray(array) {
      return shuffleArray(array)
    },
    redirect(to) {
      if (to.type === 'router') {
        this.$router.push({
          name: to.name,
          params: to.params
        })
      } else if (to.type === 'link') {
        window.open(to.link, '_blank')
      } else if (to.type === 'href-with-lang') {
        window.open(to.link.replace('{lang_code}', this.$route.params.lang), to.external ? '_blank' : '_self')
      } else if (to.type === 'external-link') {
        console.log(to, to.link_type, to.link_id)
        const url = this.getEditableInfo(to.link_type, to.link_id)
        window.open(url, '_blank')
      } else if (to.type === 'email') {
        window.location.href = `mailto:${to.email_address}`
      } else if (to.type === 'hubspot') {
        if (to.portal_id) {
          this.showFormDialog(to.portal_id, to.form_id)
        } else if (to.portalId) {
          this.showFormDialog(to.portalId, to.formId)
        }
      }
    },
    showFormDialog(portalId, formId) {
      const script = document.createElement('script')
      script.src = 'https://js.hsforms.net/forms/v2.js'
      document.body.appendChild(script)
      script.addEventListener('load', () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            portalId: portalId,
            formId: formId,
            errorClass: 'hubspotFormError',
            target: '#hubspotForm'
          })
        }
      })
      this.$nextTick(() => {
        this.$refs['hubspotFormModal'].show()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.flex-row {
    display: flex;
    flex-direction: row;
}
.main-container {
  // min-height: 1000px;
}
@media (max-width: 992px) {
  .main-container {
    min-height: 0;
  }
}
.tag-container {
  a:hover {
    color: #57abf0;
    cursor: pointer;
  }
  .dropdown-item {
    width: 100%;
    white-space: normal;
  }
  .show-more-button {
    border-radius: 0.5rem;
  }
}
.category-filter {
  white-space: normal;
  word-break: break-word;
  word-wrap: break-word;
}
.api-category {
  white-space: normal;
  word-break: break-word;
  word-wrap: break-word;
}
.disabled {
    pointer-events:none;
    color: #D3D3D3;
}
.result-container {
  display: flex;
  justify-content: center;
  font-size: 20px;
}
.result-container .no-result {
  text-align: center;
}
.result-container img {
  width: 320px;
  margin-bottom: 20px;
}
.none {
  display: none;
}
.loading-container {
  height: 45vh;
}
.info-message-box {
  display: flex;
  padding: 12px 20px;
  background-color: #E7F3FD;
  border-radius: 5px;
  .info-message-icon {
    color: #57ABF0;
    margin-top: 6px;
    margin-right: 16px;
  }
  .info-message-text {
    display: inline-block;
    .info-title {
      font-size: 16px;
      font-weight: 600;
      color: #57ABF0;
      word-break: break-word;
      display: block;
      margin-bottom: 8px;
    }
    .info-description {
      font-size: 14px;
      font-weight: 400;
      color: #57ABF0;
      word-break: break-word;
      margin-bottom: 0px;
      display: inline;
    }
  }
}
.link-text {
  cursor: pointer;
  text-decoration: underline;
}
.cursor-pointer {
  cursor: pointer;
}
.invisible {
  visibility: hidden;
}
.category-banner-description {
  font-size: 14px;
}
.link-text {
  color: #57ABF0;
  text-decoration: none;
  &:hover {
    color: #007DBA;
  }
}
</style>
